import script from "./MobileMajorSituation.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileMajorSituation.vue?vue&type=script&lang=ts&setup=true"

import "./MobileMajorSituation.vue?vue&type=style&index=0&id=72e949b7&scoped=true&lang=css"
import "./MobileMajorSituation.vue?vue&type=style&index=1&id=72e949b7&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e949b7"]])

export default __exports__